import React, { useEffect, useState, useContext } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { GlobalProvider } from "./Contexts/GlobalContext";
import {
  Home as BlogHome,
  Article as ArticleContainer,
  About,
  Contact,
} from "./Blog/containers";
import { Main, EditAnimation, Profile } from "./Analysis/containers";
import {
  Home,
  Four0four,
  CabbStats,
  Glosary,
  ProfileStats,
  Suscriptions,
  SuccessSuscription,
  ThankYou,
  TeamProfile,
  Analytics,
  Games,
  Game,
  PlayerCard,
  Lineups,
  DndDashboard,
  AnalyticsDashboard,
  ScatterPlots,
  SharedBoard,
  BoardCollection,
} from "./containers";
import { Register, VideoEditor, login, Test, VideoPlayerTest } from "./pages";
import secureLocalStorage from "react-secure-storage";

function App() {
  const userId = secureLocalStorage.getItem("userId");
  const [isLoaded, setIsLoaded] = useState(false);
  const [appData, setAppData] = useState({
    teams: null,
    players: null,
    games: null,
  });
  const baseUrl = "https://deportactico-vercel-serverless.vercel.app/api";

  function updateProductForm(value) {
    return setAppData((prev) => {
      return { ...prev, ...value };
    });
  }

  async function fetchTeams() {
    const response = await fetch(`${baseUrl}/teams`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      console.log(message);
      return;
    }
    const record = await response.json();
    if (!record) {
      console.log(`Record not found`);
      return;
    } else if (record) {
      updateProductForm({ teams: record });
    }
  }

  async function fetchPlayers() {
    const response = await fetch(`${baseUrl}/players`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const message = `An error has occurred: ${response.statusText}`;
      console.log(message);
      return;
    }
    const record = await response.json();
    if (!record) {
      console.log(`Record not found`);
      return;
    } else if (record) {
      updateProductForm({ players: record });
    }
  }

  useEffect(() => {
    if (!isLoaded) {
      fetchTeams();
      fetchPlayers();
    }
  }, [isLoaded]);

  return (
    <GlobalProvider initialData={appData}>
      <Router>
        <Route
          path="/"
          render={({ location }) => {
            window.gtag("set", "page", location.pathname + location.search);
            window.gtag("send", "pageview");
            return null;
          }}
        />
        <Switch>
          <Route path="/" exact component={Home} />
          {/* Blog */}
          <Route exact path="/blog" component={BlogHome} />
          <Route path="/blog/article/" component={ArticleContainer} />
          <Route path="/blog/about" component={About} />
          <Route path="/contact" component={Contact} />
          {/* Handle user */}
          <Route path="/app/login" component={login} />
          <Route path="/app/register" component={Register} />
          <Route path="/app/suscriptions" component={Suscriptions} />
          <Route
            path="/app/success-suscriptions"
            component={SuccessSuscription}
          />
          {/* Analisys */}
          <Route path="/app/main" component={Main} />
          <Route path="/app/playVideos/" component={VideoPlayerTest} />
          <Route path="/app/recordVideos" component={VideoPlayerTest} />
          <Route path="/app/editions/" component={VideoEditor} />
          <Route path="/app/edit-animation/" component={EditAnimation} />
          <Route
            path="/app/analytics"
            render={(props) => <Analytics {...props} appData={appData} />}
          />
          <Route
            path="/app/analytics-dashboard"
            render={(props) => (
              <AnalyticsDashboard
                {...props}
                appData={appData}
                userId={userId}
              />
            )}
          />
          <Route
            path="/app/games"
            render={(props) => <Games {...props} appData={appData} />}
          />
          <Route
            path="/app/game/:id"
            render={(props) => <Game {...props} appData={appData} />}
          />
          <Route
            path="/app/profile"
            render={(props) => <Profile {...props} appData={appData} />}
          />
          {/* CABB STATS */}
          <Route path="/glosary/" component={Glosary} />
          <Route
            path="/estadisticas"
            render={(props) => <CabbStats {...props} appData={appData} />}
          />
          <Route
            path="/statsProfile"
            render={(props) => <ProfileStats {...props} appData={appData} />}
          />
          <Route
            path="/teamProfile"
            render={(props) => <TeamProfile {...props} appData={appData} />}
          />
          <Route
            path="/playerCard/:id/season/:season"
            render={(props) => <PlayerCard {...props} appData={appData} />}
          />
          <Route
            path="/app/lineups"
            render={(props) => <Lineups {...props} appData={appData} />}
          />
          <Route
            path="/app/scatter-plots"
            render={(props) => <ScatterPlots {...props} appData={appData} />}
          />

          <Route path="/app/SharedBoard/:id" component={SharedBoard} />

          <Route
            path="/app/collection/:id"
            render={(props) => <BoardCollection {...props} appData={appData} />}
          />
          {/* Extras */}

          <Route
            path="/test/"
            render={(props) => <Test {...props} appData={appData} />}
          />
          <Route
            path="/app/dnd-dashboard"
            render={(props) => <DndDashboard {...props} appData={appData} />}
          />
          <Route
            path="/app/edit-dashboard/:id"
            render={(props) => <DndDashboard {...props} appData={appData} />}
          />
          <Route path="/four0four/" component={Four0four} />
          <Route path="/ThankYou/" component={ThankYou} />
          <Route path="*">
            <Four0four />
          </Route>
        </Switch>
      </Router>
    </GlobalProvider>
  );
}

export default App;
